export default __webpack_public_path__ + "static/media/euroventCertified.b9aa342c.jpg";